// extracted by mini-css-extract-plugin
export default {"card":"y3-z"};